<template>
  <div class="Poster">  
    <div class="Poster__test">
      <img :src="require('@/commons/img/poster.png')"/>
    </div>  
  </div>
</template>

<script>


export default {
  name: 'Poster',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Poster
    position absolute
    width 100vw
    height 100%
    color white
    background #81849f
    display flex 
    align-items center
    justify-content center

    &__test 
      max-width 480px

</style>